/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EngagementResultsStatusEnum {
    Draft = 'Draft',
    InProgress = 'In progress',
    ProcessingResults = 'Processing results',
    RawDataAvailable = 'Raw data available',
    InsightsAvailable = 'Insights available',
    AdminOnly = 'Admin only'
}

